import React, { useEffect, useState, useRef } from 'react'
import { ApiService } from '../API/AxiosInstance';
import Box from "@mui/material/Box";
import { CardActionArea, Skeleton,Stack,Typography,IconButton,Grid,Card,CardContent,CardMedia } from '@mui/material';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import moment from 'moment';
import { ShimmerSkeleton } from '../utils/SkimmerSkeleton';
import { captureException } from '@sentry/react';
import MainLayout from '../components/MainLayout';
// import { colors } from '../Theme/tokens';
import { useColors } from '../Theme/ColorModeContext';

export default function News() {
    const colors = useColors();
    const [newsData, setNewsData] = useState([])
    const [loading, setLoading] = useState(false)
    const [limit, setLimit] = useState(12)
    const [page, setPage] = useState(0)
    const [error, setError] = useState(false)
    const dummy = useRef(null);
    useEffect(() => {
        if (page > 0) {
          dummy.current?.scrollIntoView({ behavior: "smooth" });
        }
      }, [newsData]); 
           

    useEffect(() => {
        fetchData()
    }, [])


    const makeDate = (dateString) => {
        const date = moment(dateString, 'ddd, DD MMM YYYY HH:mm:ss ZZ').local()
        let relativeTime;
        if(moment(dateString, "ddd, DD MMM YYYY HH:mm:ss ZZ").local().format('YYYY-MM-DD') < moment(new Date()).format('YYYY-MM-DD')) {
            relativeTime = moment(dateString, "ddd, DD MMM YYYY HH:mm:ss ZZ").local().format('DD MMM YYYY, HH:mm:ss')
        } else {
        const now = moment().local();
        relativeTime = date.from(now);
        }
        return relativeTime
    }

    const handleMore = async() => {
        setPage(prev=> prev + 1)
        await fetchData(limit + 12, page + 1)
    }

    async function fetchData(limitNews, currentPage) {
        setLoading(true)
        try {
            const response = await ApiService().get(`news?page=${currentPage ? currentPage : page}&limit=${limit}`);
            if(response.status == 200) {
                setNewsData(prev => [...prev, ...response.data.news])
                setLoading(false)
            }
        } catch (error) {
            setLoading(false)
            if(error?.response?.data?.code == "news_not_retrieved") {
                
            } else {
                captureException(error)
            } setError(true)
            
        } 
    }

    const navigateToExternalPage = (url) => {
        console.log("url ",url)
        window.open(url, '_blank')
    }  

    return (
        <>
            <MainLayout>
                <Box  sx={{
                    backgroundColor: colors.background.paper,
                    borderRadius: '18px',
                    padding: { sm: '20px', xs: '20px 0px 20px 0px' },
                    position: 'relative',
                    marginBottom: '30px',
                    boxShadow: `0px 1px 5px 0px ${colors.border.card}`,
                }}>
                    <Typography variant='h2' px={1} py={1} sx={{fontWeight:"600",color: colors.text.primary}}>Latest News</Typography>
                    <Box mt='15px' sx={{
                        display: 'grid',
                        gridTemplateColumns: {
                            xs: 'repeat(auto-fit, minmax(280px, 1fr))',
                            sm: 'repeat(auto-fit, minmax(300px, 1fr))',
                            md: 'repeat(auto-fit, minmax(260px, 1fr))',
                            lg: 'repeat(auto-fit, minmax(220px, 1fr))',
                            xl: 'repeat(auto-fit, minmax(320px, 1fr))',
                        },
                        justifyItems: 'stretch',
                        gap: { xs: '16px', sm: '20px', md: '20px', lg: '24px', xl: '24px' },
                    }}>
                        {(newsData?.length > 0 || !loading) ? (newsData.map((itm, index) => {
                            return (
                                <Card key={index} onClick={() => navigateToExternalPage(itm?.news_url)} sx={{
                                    height: 'auto',
                                    boxShadow: `0px 1px 5px 0px ${colors.border.card}`,
                                    padding: "16px",
                                    width: "100%",
                                }}>
                                    <CardActionArea>
                                        <CardMedia component='img' sx={{
                                            height: "150px",
                                            borderRadius: '7px'
                                        }}
                                            image={itm.image_url}
                                        />
                                        <CardContent sx={{
                                            padding: '0px'
                                        }}>
                                            <Typography mt='10px' sx={{ fontWeight: "600", fontSize: "15.44px", lineHeight: "19.41px", color: colors.neutral.outlinedText }}> {itm.title}</Typography>
                                            <Typography mt='10px' sx={{ fontWeight: "400", fontSize: "10.73px", lineHeight: "9.05px", color: colors.text.secondary }}> {itm?.date ? makeDate(itm?.date) : ''}</Typography>
                                        </CardContent>
                                    </CardActionArea>
                                </Card>
                            )
                        })) : (
                            <Box sx={{ display: 'flex', flexDirection: 'row', flexWrap: 'wrap', justifyContent: 'center', row: { xs: '20px' }, gap: 4 }}>
                                {[1, 2, 3, 4, 5, 6, 7, 8, 9]?.map(() => (
                                    <ShimmerSkeleton sx={{ width:"250px", height: "130px" }} />
                                ))}
                            </Box>
                        )}
                        {/* After click more button */}
                        {/* {loading && newsData?.length > 0 && <Box sx={{ display: 'flex', flexDirection: 'row', flexWrap: 'wrap', justifyContent: 'center', row: { xs: '20px' }, gap: 4 }}>
                            {[1, 2, 3, 4, 5, 6, 7, 8, 9]?.map(() => (
                                <ShimmerSkeleton sx={{ width: "250px", height: "130px" }} />
                            ))}
                        </Box>} */}
                         {/* After click more button — now direct grid children, no wrapping Box */}
    {loading && newsData?.length > 0 && [1, 2, 3, 4, 5, 6, 7, 8, 9]?.map((n) => (
        <ShimmerSkeleton key={`load-more-${n}`} sx={{ width: "100%", height: "130px" }} />
    ))}
                    </Box>
                    {!error && <IconButton
                    onClick={handleMore}
                    component='div' sx={{
                        position: 'absolute',
                        zIndex: '1',
                        bottom: '-20px',
                        right: '48%',
                        width: '50px',
                        height: '50px',
                        backgroundColor: colors.background.paper,
                        borderRadius: '100px',
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        boxShadow: '0 0 10px 0 rgba(0,0,0,0.2)',
                        color: colors.primary.main,
                        transition: '.3s'
                    }}>
                        <KeyboardArrowDownIcon sx={{
                            fontSize: '2rem'
                        }} />

                    </IconButton>}
                </Box>
            </MainLayout>
        </>
    )
}
